export default __webpack_public_path__ + "static/media/icon-arrow_active.5a66a822.svg";